import React from 'react'
import Photo from "../../../../Assests/Products/Hospitalmang/feedback.png"
const  Survey= () => {
    return (
        <div className='HosAnalysis'>
            <div className="HosAnalysis-Photo" data-aos="zoom-in-right">
                <img src={Photo} alt='' />
            </div>
            <div className="HosAnalysis-Def" data-aos="zoom-in-right">
                <h2>
                    Survey and Patient Feedback System
                </h2>
                <p>
                Gather and analyze patient feedback to continually improve service quality and patient satisfaction.
                </p>

            </div>
        </div>
    )
}

export default Survey